import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledLoadingPage = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: #121212;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding-top: 160px;
    text-align: center;
    color: #ffffff;
    font-size: 40px;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    background-image: url(${require('assets/images/invite/bg-top.png')}),
        url(${require('assets/images/invite/bg-bottom.png')});
    background-size: contain;
    background-position: right top, center bottom;
    background-repeat: no-repeat;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        background-image: url(${require('assets/images/invite/bg-top.png')}), url(${require('assets/images/invite/mobile-bg-bottom.png')});
    `};
`;

const items = ['Explore', 'GOAT', 'Universe'];

const TypingEffect = () => {
    const [text, setText] = useState('');
    const [index, setIndex] = useState(0);
    const [count, setCount] = useState(0);

    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout>;
        const typingEffect = () => {
            const currentText = items[index];
            if (count < currentText.length) {
                timeoutId = setTimeout(() => {
                    setText((prev) => prev + currentText[count]);
                    setCount((prev) => prev + 1);
                }, Math.floor(Math.random() * 100));
            } else {
                setTimeout(() => {
                    setText('');
                    setCount(0);
                    setIndex((prevIndex) => (prevIndex + 1) % items.length);
                }, 1000);
            }
        };

        typingEffect();

        return () => {
            clearTimeout(timeoutId);
        };
    }, [count, index]);

    return <div>{text}</div>;
};

const Loading = () => {
    return (
        <StyledLoadingPage>
            <TypingEffect />
        </StyledLoadingPage>
    );
};

export default Loading;
